import React from 'react';
import './Footer.css';

const Footer = ({ setCurrentPage }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Prangio Designs</h3>
            <p>Creating exceptional spaces that inspire and enhance your lifestyle through innovative architecture and interior design.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook">📘</a>
              <a href="#" aria-label="Instagram">📷</a>
              <a href="#" aria-label="LinkedIn">💼</a>
              <a href="#" aria-label="Twitter">🐦</a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Architectural Design</a></li>
              <li><a href="#services">Interior Design</a></li>
              <li><a href="#services">Renovation & Remodeling</a></li>
              <li><a href="#services">Consultation</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); setCurrentPage('careers'); }}>Careers</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <p>📍 21/22, Alandur Road,<br />WeWork Olympia Cyberspace,<br />Arulayiammanpet, 2nd Street, Guindy, Chennai 600032</p>
              <p>📞 +91 (776) 003-4934</p>
              <p>✉️ prangiodesigns@gmail.com</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Prangio Designs Pvt. Ltd. All rights reserved.</p>
          <div className="footer-center">
            <p>Powered by <a href="https://www.dynamworks.com" target="_blank" rel="noopener noreferrer">DynamWorks</a></p>
          </div>
          <div className="footer-links">
            <a href="#" onClick={(e) => { e.preventDefault(); setCurrentPage('privacy'); }}>Privacy Policy</a>
            <a href="#" onClick={(e) => { e.preventDefault(); setCurrentPage('terms'); }}>Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
